import { useContext, useState, useEffect } from "react"
import { UserContext } from "../../contexts/UserContext"
import { NotificationBox } from "./NotificationBox"
import { NotificationBoxSmall } from "./NotificationBoxSmall"

export function NotificationRender({ notification }) {
    const [notificationPopup, setNotificationPopup] = useState(false)

    useEffect(() => {
        if (notification) {
            setNotificationPopup(true)
        }
    }, [notification])

    useEffect(() => {
        const timer = setTimeout(() => setNotificationPopup(false), 9000)
    }, [notificationPopup])

    return (
        notification &&
            window.innerWidth >= 992 ?
                <NotificationBox
                    notification={notification}
                    notificationPopup={notificationPopup}
                    setNotificationPopup={setNotificationPopup}
                />
                :
                <NotificationBoxSmall
                    notification={notification}
                    notificationPopup={notificationPopup}
                    setNotificationPopup={setNotificationPopup}
                />   
    )
}